import React from "react";

const Footer = () => {

    return (
        <>
            <footer>
                <p>Copyright &copy; MOVI - movie & game</p>
            </footer>
        </>
    )
}

export default Footer